import React from 'react';
import { Text } from '@wearejh/rx-form/lib/compat/informed';

import { basicPresenceValidation } from 'src/util/forms';
import { Button } from 'src/components/Button/Button';

import classes from './InlineSubmit.scss';

type Props = {
    field: string;
    submitText?: string;
    placeholder?: string;
};

export function InlineSubmit(props: Props) {
    return (
        <div className={classes.root}>
            <Text
                field={props.field}
                id={props.field}
                type="text"
                validate={basicPresenceValidation()}
                placeholder={props.placeholder}
            />
            <Button data-test-id="InlineSubmit__Button" variant="primary" type="submit">
                {props.submitText || 'Submit'}
            </Button>
        </div>
    );
}
